import React, {Component} from "react";
import SimpleModal from "../../../../../../modules/popup/SimpleModal";
import Button from "../../../../../../modules/commons/Button";
import ModalContainer from "../../../../../../modules/commons/ModalContainer";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import Api from "../../../../../../Services/Api";
import * as R from 'ramda';
import SimpleLoadingOverlay from "../../../../../../modules/popup/SimpleLoadingOverlay";
import SimpleCheckBox from '../../../../../../modules/SimpleCheckBox';
import { defaultTableChange } from "../../../../../../modules/custom/customTable";

class MutasiBarangDetailPilihUnit extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, {rowIndex}) => <>{rowIndex + 1}</>,
                setCellProps: () => ({style: {width: "5%"}})
            }
        },
        {name: "kodeVariant", label: "Kode Variant"},
        {name: "namaVariant", label: "Nama Variant"},
        {name: "kodeWarna", label: "Kode Warna"},
        {name: "namaWarnaKomersil", label: "Nama Warna"},
        {name: "nosin", label: "Nosin"},
        {name: "noka", label: "Noka"},
        {name: "nameLocator", label: "Locator"},
        {name: "umur", label: "Usia"},
        {
            name: "", label: "Aksi", options: {
                customBodyRender: (val, {rowIndex}) => (
                    <SimpleCheckBox
                        id="checkbox_action"
                        checked={this.state.unitChosen?.includes(rowIndex)}
                        onChange={() => this.handlePilih(rowIndex)}
                    />
                )
            }
        }
    ];

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            namaVariant: "",
            namaWarna: "",
            data: [],
            chosenData: [],
            unitChosen: [],
            noUnitChosen: false,
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            },
        }
    }

    async componentDidMount() {
        this.handleTriggerLoading();
        await this.fetchDataUnit();
        this.handleTriggerLoading();
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }))
    }

    fetchDataUnit = async () => {
        const index = this.props.index;
        const variant = this.props.state.data.mutationUnits[index]?.kodeVariant || null;
        const warna = this.props.state.data.mutationUnits[index]?.kodeWarna || null;
        const arrNosin = this.props.state.data?.mutationUnits.map(item => item?.nosin)?.filter(val => val)
        const request = {
            kodeLocator: this.props.state.data.mutationSourceKodeLocator.value,
            kodeVariant: variant ? variant.value : null,
            kodeWarna: warna ? warna.value : null,
            unitStatus: "IN_STOCK",
            noSin: arrNosin,
            kodeCabang: this.props.state.data.mutationSourceKodeCabang?.value
        }
        const namaVariant = variant ? variant.namaVariant : "";
        const namaWarna = warna ? warna.label : "";
        const response = await Api.create("NAGAMAS_TRANSACTION").getUnitList(request);
        if (response.ok && !R.isEmpty(response.data.data)) {
            const kodeLocator = response.data.data.kodeLocator;
            const nameLocator = this.props.state.data.mutationSourceKodeLocator.label;
            const listUnit = response.data.data.listUnit;
            this.setState((prevValue) => ({
                ...prevValue,
                namaVariant: namaVariant,
                namaWarna: namaWarna,
                data: listUnit.map((kv) => ({
                    kodeVariant: kv.variant.kodeVariant,
                    namaVariant: kv.variant.namaVariant,
                    kodeWarna: kv.warna.kodeWarna,
                    idWarna: kv.warna.id,
                    namaWarnaKomersil: kv.warna.namaWarnaKomersil,
                    nosin: kv.nosin,
                    noka: kv.noka,
                    kodeLocator: kodeLocator,
                    nameLocator: nameLocator,
                    umur: kv.umur,
                }))
            }));
        }
    }

    handlePilihSingleUnit = (index) =>{
         this.setState((prevValue) => ({
            ...prevValue,
            chosenData: [this.state.data[index]],
            unitChosen: [index],
        }));
    }

    handlePilih = (index) => {
        if(this.props.isSingleSelectUnit){
            return this.handlePilihSingleUnit(index)
        }
        this.setState((prev) => {
         const { unitChosen = [], chosenData = [] } = prev;
        const exists = !!unitChosen?.includes(index);

        return {
          ...prev,
          chosenData: exists
            ? chosenData.filter((_, i) => i !== index)
            : [...chosenData, this.state.data[index]],
          unitChosen: exists
            ? unitChosen?.filter((item) => item !== index)
            : [...unitChosen, index],
        };
      });
    };

    handleSubmit = () => {
        if (this.state.chosenData.length > 0)
            this.props.onSubmit(
              this.props.isSingleSelectUnit
                ? this.state.chosenData[0]
                : this.state.chosenData
            );
        else
            this.handleNoUnitChosen();
    }

    handleNoUnitChosen = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            noUnitChosen: !prevValue.noUnitChosen,
        }))
    }

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        const { pagination } = this.state
        return (
            <>
                <SimpleModal
                    title={"Cek No. Rangka/ No. Mesin"}
                    visible={this.props.visible}
                    onClickClose={this.props.onClickClose}
                    content={
                        <ModalContainer>
                            <FlexView className={"margin-left-10px margin-bottom-20px"}>
                                <FlexView column>
                                    <p>{`Nama Variant\t\t: ${this.state.namaVariant}`}</p>
                                    <p>{`Warna\t\t: ${this.state.namaWarna}`}</p>
                                </FlexView>
                            </FlexView>
                            <SimpleDataTable
                                key={`${this.state.data?.length}-${pagination.page}`}
                                data={this.state.data}
                                columns={this.tableColumns}
                                toCount={this.state.data?.length}
                                rowsPerPage={pagination.limit}
                                page={pagination.page - 1}
                                options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                            />
                            <FlexView hAlignContent="right" className="margin-top-15px">
                                <SimpleButton
                                    secondary
                                    onClick={this.handleSubmit}
                                >
                                    Pilih Nosin/Noka
                                </SimpleButton>
                            </FlexView>
                        </ModalContainer>
                    }
                />
                {this.state.noUnitChosen && (
                    <SimpleModal
                        title={"No Unit Chosen"}
                        visible={this.state.noUnitChosen}
                        onClickClose={this.handleNoUnitChosen}
                        content={<ModalContainer>
                            <p>No Unit Chosen</p>
                        </ModalContainer>}
                    />
                )}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        )
    }
}

export default MutasiBarangDetailPilihUnit;